import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button"]
  static values = { agreement: String }

  connect() {
    this.checkAgreement()
    this.bindModalEvents()
  }

  disconnect() {
    this.unbindModalEvents()
  }

  checkAgreement() {
    const inputValue = this.inputTarget.value.trim().toLowerCase()
    const requiredText = this.agreementValue.toLowerCase()
    
    if (inputValue === requiredText) {
      this.enableButton()
    } else {
      this.disableButton()
    }
  }

  enableButton() {
    this.buttonTarget.classList.remove("disabled")
    this.buttonTarget.style.pointerEvents = "auto"
    this.buttonTarget.removeAttribute("tabindex")
  }

  disableButton() {
    this.buttonTarget.classList.add("disabled")
    this.buttonTarget.style.pointerEvents = "none"
    this.buttonTarget.setAttribute("tabindex", "-1")
  }

  reset() {
    this.inputTarget.value = ""
    this.disableButton()
  }

  bindModalEvents() {
    const modal = this.element.closest('.modal')
    if (modal) {
      this.modalElement = modal
      this.handleModalHidden = this.handleModalHidden.bind(this)
      modal.addEventListener('hidden.bs.modal', this.handleModalHidden)
    }
  }

  unbindModalEvents() {
    if (this.modalElement) {
      this.modalElement.removeEventListener('hidden.bs.modal', this.handleModalHidden)
    }
  }

  handleModalHidden() {
    this.reset()
  }
}